import React, { useState } from 'react';
import { useAuth } from './contexts/AuthContext';
import { Link } from 'react-router-dom';
import './AuthForms.css';

export default function ForgotPassword() {
  const { requestPasswordReset } = useAuth();
  const [email, setEmail]       = useState('');
  const [message, setMessage]   = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setLoading(true);
    try {
      await requestPasswordReset(email);
      setMessage('If an account exists for this email, you will receive reset instructions.');
    } catch (err) {
      setError(err?.message || 'Failed to send reset email.');
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={handleSubmit}>
        <h2 className="auth-title">Forgot Password</h2>
        {message && (
          <div className="auth-info" aria-live="polite">{message}</div>
        )}
        {error && (
          <div className="auth-error" aria-live="polite">{error}</div>
        )}

        <div className="auth-group">
          <label htmlFor="fp-email">Email</label>
          <input
            type="email"
            id="fp-email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            placeholder="you@example.com"
            disabled={loading}
            aria-disabled={loading}
          />
        </div>

        <button type="submit" className="auth-button" disabled={loading}>
          {loading ? 'Sending…' : 'Send Reset Link'}
        </button>

        <div className="auth-footer">
          <Link to="/subscribe" className="auth-link">Back to Login</Link>
        </div>
      </form>
    </div>
  );
}
